import { GateData } from "../api/models/gate-model";

const gateTypeRank = (type?: string | null) => {
  if (type === "entrance") return 0;
  if (type === "exit") return 1;
  return 2;
};

/** Entrance gates first, then exit. Same type keeps the API order. */
export const sortGatesEntranceFirst = (
  gates: GateData[] | null,
): GateData[] | null => {
  if (!gates) return null;
  return [...gates].sort(
    (a, b) => gateTypeRank(a?.type) - gateTypeRank(b?.type),
  );
};
